module.exports = __webpack_public_path__ + "static/media/appstore.5ee5ee01.svg";